// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"377":"0dfd12a6","998":"0f8faefd"}[chunkId] + ".chunk.js";
};